"use client";
import { useState } from "react";
import { m } from "framer-motion";
import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function CheckMarks({ points }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const isdark = useIsDark();

  return (
    <section>
      <ul className="flex flex-col gap-3 md:gap-5 tablet:gap-10 laptop:gap-18">
        {points.map((point, index) => (
          <li
            key={index}
            className={twMerge("flex items-start gap-4 xl:gap-[35px] font-alexandria font-normal text-[16px] sm:text-[17px] md:text-[18px] xl:text-[22px] 3xl:text-[25px] 4xl:text-[28px]", !isdark && "text-[#570069]")}
          >
            <m.div
              animate={{ scale: hoveredIndex === index ? 1.2 : 1 }}
              transition={{ duration: 0.3, type: "spring" }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="flex-none"
            >
              <img
                src="/assets/purpleCheckmark.svg"
                alt="checkmark"
                className="w-[25px] h-[25px] xl:w-[50px] xl:h-[50px] object-contain shrink-0 mt-1"
              />
            </m.div>

            <m.div
              animate={{ x: hoveredIndex === index ? 10 : 0 }}
              transition={{ duration: 0.3, type: "spring" }}
            >
              <p>{point.content1}</p>
              {point.content2 && <p>{point.content2}</p>}
            </m.div>
          </li>
        ))}
      </ul>
    </section>
  );
};
